import { CSRF_HEADER } from "@esi/shared";
import { api } from "../api.ts";
import { broadcastSessionEnded, markSigningOut } from "./session-ended.ts";

/** Ends the session through the API, then follows its redirect (the IdP's logout or home). */
export async function signOut(csrfToken: string): Promise<void> {
  // Polling queries may get a 401 meanwhile: they must not send this tab to sign-in, which
  // would replace the IdP logout navigation and sign the person straight back in.
  markSigningOut();
  try {
    const res = await api.api.auth.logout.$post(undefined, {
      headers: { [CSRF_HEADER]: csrfToken },
    });
    const body = await res.json();
    // The other tabs of this browser leave their pages too (they shared this session).
    if (res.ok) {
      broadcastSessionEnded("signed_out");
    }
    window.location.assign(res.ok && "redirect" in body ? body.redirect : "/");
  } catch {
    // The session may be gone already: the sign-in page is the right place either way.
    window.location.assign("/");
  }
}
